//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "PodcastCard",
    props: ["item"],
    computed: {
        duration: function() {
            return Math.round(this.item.secondsDuration / 60);
        }
		},
    methods: {
        getESTDate(date) {
            var dt = new Date(Date.parse(date));
            var offset = dt.getTimezoneOffset();
            dt.setTime(dt.getTime() + (offset * 60 * 1000));
            //console.log('Result: ', date, new Date(Date.parse(date)), dt, offset);
            if (dt.getFullYear() < 1900) return '';
            return [dt.getMonth()+1, dt.getDate(), dt.getFullYear()].join('/');
        }
    }
};
